import { Switch } from '@chakra-ui/react';
import { useEditPortfolio } from 'services/queryClient/wrapperHooks/portfolio/useEditPortfolio';

interface IOrderBacklogSwitchToggleProps {
	id: number;
	checked: boolean;
}
export function OrderBacklogSwitchToggle(
	props: IOrderBacklogSwitchToggleProps
): JSX.Element {
	const { id, checked } = props;

	const body: {
		ruim: boolean;
	} = {
		ruim: !checked,
	};

	const { mutate } = useEditPortfolio(id, undefined, 'toggle');

	const updateItem = (): void => {
		mutate(body);
	};

	return (
		<Switch
			colorScheme='red'
			size='sm'
			isChecked={checked}
			onChange={updateItem}
		/>
	);
}
